
<section class="hero is-warning is-medium">
	<div class="hero-body">
		<div class="container">
			<h1 class="title">404</h1>
			<h2 class="subtitle">Page not found</h2>
		</div>
	</div>
</section>
